import { ApiCaller } from './restApiCaller';

export const buildApiCallerForAxios = (axios: any): ApiCaller => {
    return {
        call: axios,
        is4xxError: (errMsg: string) => errMsg.startsWith('Error: Request failed with status code 4'),
        is5xxError: (errMsg: string) => errMsg.startsWith('Error: Request failed with status code 5')
    };
};
